module.exports = __webpack_public_path__ + "static/media/bg-mist.3dd35bfd.jpg";